export const sceneBgColor = 0xf7f9fa;
